<div class="complex-filter-date">
  <form class="form">
    <div class="complex-filter-date__container"></div>
    <ftr-date-picker
      label="Date"
      [control]="dateControl"
      [clearDate]="clearDateSubject.asObservable()"
      [showValidation]="false"
    ></ftr-date-picker>
  </form>
</div>
